import { Box } from "@mui/material";
import React from "react";
import EMIcalculator from "../../modules/EMi/EMIcalculator";
import LoanProcess from "../../modules/EMi/LoanProcess";
import SwiperBox from "../../modules/EMi/SwiperBox";
import OperationalCities from "../../modules/Finance/operationalCities";
import HomePageFAQs from "../../modules/Home/HomePageFAQs/homePageFAQs";
import HappyCustomers from "../../modules/Home/HomePageRevamp/happyCustomers";
import LatestModel from "../../modules/Home/HomePageRevamp/latestModel";

const EmiMain = ({ vehiclesData, showHeader }) => {
  return (
    <>
      <EMIcalculator
        vehiclesData={vehiclesData}
        showHeader={showHeader ?? true}
      />
      {/* <CarouselOffers/> */}
      <Box sx={{ width: { md: "88%", xs: "100%" }, margin: "50px auto" }}>
        <LatestModel />
      </Box>
      <Box sx={{ width: { md: "85%", xs: "100%" }, margin: "18px auto" }}>
        <LoanProcess />
      </Box>
      <Box sx={{ display: { md: "none", xs: "block" } }}>
        <HappyCustomers title="Customers love our easy loans" />
      </Box>
      <SwiperBox />
      <OperationalCities
        headerInfo={"India's largest Commercial Vehicles Marketplace"}
      />
      <HomePageFAQs />
    </>
  );
};

export default EmiMain;
